module.exports = __webpack_public_path__ + "img/chiller.a431703c.jpg";